<template>
  <v-row>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3" v-for="(key, i) in language_details_keys" :key="`lang-${i}`">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">{{ i18n[key] }}</span>
      <br />
      <span v-if="!key.includes('_date')">{{ transform(resource[key], key) }}</span>
      <v-chip color="blue" dark small v-else-if="transform(resource[key], key) != ''">{{ transform(resource[key], key) }}</v-chip>
      <v-chip v-else small color="orange" dark>{{ i18n.not_set }}</v-chip>
    </v-col>
    <v-col cols="12">
      <v-btn small color="primary" @click.prevent="$emit('editResource', 'recognation', {})">Edit</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["resource"],
  data() {
    return {
      language_details_keys: [
        "recognition_documents_ready",
        "recognition_documents_ready_date",
        "recognition_documents_submitted",
        "recognition_documents_submitted_date",
        "recognition_documents_reviewed",
        "recognition_documents_reviewed_date",
        "recognition_documents_sent_dhl",
        "recognition_documents_sent_dhl_date",
        "recognition_documents_recieved_dhl",
        "recognition_documents_recieved_dhl_date",
        "recognition_documents_submitted_to_authority",
        "recognition_documents_submitted_to_authority_date",
        "recognition_documents_result",
        "recognition_documents_result_date",
      ],
    }
  },
  methods: {
    /**
     * @param {string} date 
     */
    formatDateToCurrentLocale(date) {
      if (!date || date.trim() == '') return ['', ''] 
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    /**
     * 
     * @param {string} value
     * @param {string} key 
     */
    transform(value, key) {
      return key.includes("_date") ? this.formatDateToCurrentLocale(value)[0] : (Boolean(value) ? 'Yes' : 'No')
    },
  },
  computed: {
    visaKeys() {
      return Object.keys(this.resource).filter((key) => key.startsWith("visa_"));
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
};
</script>
